import React from 'react';
import styles from './PaymentInvoices.module.css';
import {
  fmtNum,
  fmtCurr,
  fmtDateShort,
  fmtDate,
  STATUS_TAG,
  STATUS_LABEL,
} from './helpers';

const InvoiceDrawer = ({
  invoice,
  isOpen,
  onClose,
  onViewFull,
  onPdfDownload,
  onCsvDownload,
  onResend,
}) => {
  if (!isOpen) return null;

  const tagClass = invoice
    ? styles[STATUS_TAG[invoice.status]] || styles.tagGy
    : '';
  const statusLabel = invoice?.status || '';

  return (
    <>
      <div className={styles.drawerOverlay} onClick={onClose} />
      <div className={styles.drawer}>
        <div className={styles.drawerHeader}>
          <div>
            <div className={styles.drawerTitle}>
              {invoice?.invoiceNumber ?? 'Invoice Details'}
            </div>
            <div className={styles.drawerSub}>
              {invoice
                ? `${invoice.placeName ??
                    invoice.company?.name ??
                    ''} · ${fmtDateShort(
                    invoice.period?.from,
                  )} – ${fmtDateShort(invoice.period?.to)}`
                : ''}
            </div>
          </div>
          <button
            className={`${styles.btn} ${styles.btnIcon}`}
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className={styles.drawerBody}>
          {invoice && (
            <>
              <div className={styles.drSection}>
                <div className={styles.drSectionTitle}>Invoice Summary</div>
                {[
                  [
                    'Invoice No.',
                    <span
                      style={{
                        fontFamily: 'monospace',
                        fontSize: 11,
                        color: 'var(--or)',
                      }}
                    >
                      {invoice.invoiceNumber}
                    </span>,
                  ],
                  [
                    'Status',
                    <span className={`${styles.tag} ${tagClass}`}>
                      {statusLabel}
                    </span>,
                  ],
                  // ['Place', invoice.placeName ?? '—'],
                  ['Company', invoice.company?.name ?? '—'],
                  [
                    'Period',
                    `${fmtDateShort(invoice.period?.from)} – ${fmtDateShort(
                      invoice.period?.to,
                    )}`,
                  ],
                  ['Total Orders', fmtNum(invoice.orderCount)],
                ].map(([k, v]) => (
                  <div key={k} className={styles.drRow}>
                    <span className={styles.drKey}>{k}</span>
                    <span className={styles.drVal}>{v}</span>
                  </div>
                ))}
              </div>

              <div className={styles.drSection}>
                <div className={styles.drSectionTitle}>Financial Summary</div>
                <div className={styles.finBox}>
                  {[
                    [
                      'Total Sale Value (incl. GST)',
                      fmtCurr(invoice.saleValue),
                      'var(--ink)',
                    ],
                    [
                      'KRAVEiN Fee',
                      `-${fmtCurr(invoice.kraveinFee)}`,
                      'var(--rd)',
                    ],
                    [
                      'Net Payout (incl. GST)',
                      fmtCurr(invoice.netPayout),
                      'var(--gr)',
                    ],
                    ['GST', fmtCurr(invoice.subTotalGst), 'var(--gr)'],
                  ].map(([k, v, c]) => (
                    <div key={k} className={styles.finRow}>
                      <span className={styles.finKey}>{k}</span>
                      <span className={styles.finVal} style={{ color: c }}>
                        {v}
                      </span>
                    </div>
                  ))}
                  <div className={styles.finNote}>
                    GST includes in KRAVEiN Fee
                  </div>
                </div>
              </div>

              <div className={styles.drSection}>
                <div className={styles.drSectionTitle}>Document Storage</div>
                {[
                  ['PDF (S3)', invoice.pdfS3Key ?? '—'],
                  ['CSV (S3)', invoice.csvS3Key ?? '—'],
                ].map(([k, v]) => (
                  <div key={k} className={styles.drRow}>
                    <span className={styles.drKey}>{k}</span>
                    <span className={styles.drVal}>{v}</span>
                  </div>
                ))}
              </div>

              <div className={styles.drSection}>
                <div className={styles.drSectionTitle}>
                  Linked Places ({invoice.places?.length ?? 0})
                </div>
                {invoice.places?.length > 0 ? (
                  invoice.places.map(place => (
                    <div key={place.placeId} className={styles.drRow}>
                      <span className={styles.drKey}>{place.name}</span>
                      <span className={styles.drVal}>
                        {[place.addressLine1, place.city, place.state]
                          .filter(Boolean)
                          .join(', ')}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className={styles.drRow}>
                    <span className={styles.drKey}>Places</span>
                    <span className={styles.drVal}>—</span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className={styles.drawerFooter}>
          <button
            className={`${styles.btn} ${styles.btnPrimary}`}
            style={{ flex: 1, justifyContent: 'center' }}
            onClick={onViewFull}
          >
            👁 Full Invoice View
          </button>
          <button
            className={`${styles.btn} ${styles.btnSecondary} ${styles.btnSm}`}
            onClick={() => onPdfDownload(invoice)}
          >
            ⬇ PDF
          </button>
          <button
            className={`${styles.btn} ${styles.btnSecondary} ${styles.btnSm}`}
            onClick={() => onCsvDownload(invoice)}
          >
            ⬇ CSV
          </button>
          <button
            className={`${styles.btn} ${styles.btnSecondary}`}
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default InvoiceDrawer;
